/** @format */

import { combineReducers } from "redux";
import auth from "./auth";
import rooms from "./rooms";

export const reducers = combineReducers({ auth, rooms });
